module.exports = __webpack_public_path__ + "img/profess3.75424670.png";